import React, { useCallback, useState } from 'react'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'
import PropTypes from 'prop-types'
import { THEME } from '../../../../core/constants'
import {
  VERBOSE,
  DEBUG,
  INFORMATION,
  WARNING,
  ERROR,
  FATAL,
  SCRAPING_LOGS_SEVERITIES,
} from '../../../constants'

const colorBySeverity = {
  [VERBOSE]: THEME.colors.blue,
  [DEBUG]: THEME.colors.blue,
  [INFORMATION]: THEME.colors.blue,
  [WARNING]: THEME.colors.yellow,
  [ERROR]: THEME.colors.red,
  [FATAL]: THEME.colors.red,
}

const ScrapingLogSeverityFilter = ({ severity, onChange }) => {
  const [value, setValue] = useState()

  const handleChange = useCallback(
    severity => {
      setValue(severity)
      onChange(severity)
    },
    [onChange, setValue],
  )

  return (
    <Form.Item label="Severity">
      <Select
        style={{ width: '100%' }}
        allowClear
        defaultValue={severity}
        onChange={handleChange}
        value={value}
      >
        {map(SCRAPING_LOGS_SEVERITIES, ({ name, value }) => (
          <Select.Option
            key={value}
            value={value}
            style={{
              color: colorBySeverity[value],
            }}
          >
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

ScrapingLogSeverityFilter.propTypes = {
  severity: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

ScrapingLogSeverityFilter.defaultProps = {
  severity: undefined,
}

export default ScrapingLogSeverityFilter
